package com.yendo.mx.models

import kotlinx.serialization.Serializable

@Serializable
data class SeccionHome(
    val id: String = "",
    val tipoBloque: String = "",
    val orden: Int = 0,
    val activo: Boolean = true,
    val vistaDestino: String = "HOME", // 🚀 "HOME", "COMIDA" o "COMERCIOS"
    val zonasValidas: List<String> = listOf("TODAS"),
    val titulo: String = "",
    val etiquetaBusqueda: String = "",
    val idsManuales: List<String> = emptyList(),
    val listaBanners: List<BannerYendo> = emptyList(),
    val negocios: List<RestauranteFirebase> = emptyList(),
    val productos: List<Producto> = emptyList()
)

@Serializable
data class BannerYendo(
    val id: String = "",
    val imagenUrl: String = "",
    val texto: String = "",
    val tipoAccion: String = "NADA",
    val destinoAccion: String = ""
)

@Serializable
data class FiltroHome(
    val id: String = "",
    val texto: String = "",
    val tipoFiltro: String = "",
    val activo: Boolean = true,
    val orden: Int = 0,
    val zonasValidas: List<String> = listOf("TODAS")
)